export default "__VITE_ASSET__Usd0KIlw__"